module.exports = __webpack_public_path__ + "img/16.6bc930f6.jpg";